var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 5.625C5.20527 5.625 5.625 5.20527 5.625 4.6875C5.625 4.16973 5.20527 3.75 4.6875 3.75C4.16973 3.75 3.75 4.16973 3.75 4.6875C3.75 5.20527 4.16973 5.625 4.6875 5.625Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 5.625C10.5158 5.625 10.9355 5.20527 10.9355 4.6875C10.9355 4.16973 10.5158 3.75 9.99805 3.75C9.48028 3.75 9.06055 4.16973 9.06055 4.6875C9.06055 5.20527 9.48028 5.625 9.99805 5.625Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 5.625C15.8303 5.625 16.25 5.20527 16.25 4.6875C16.25 4.16973 15.8303 3.75 15.3125 3.75C14.7947 3.75 14.375 4.16973 14.375 4.6875C14.375 5.20527 14.7947 5.625 15.3125 5.625Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 10.9355C5.20527 10.9355 5.625 10.5158 5.625 9.99805C5.625 9.48028 5.20527 9.06055 4.6875 9.06055C4.16973 9.06055 3.75 9.48028 3.75 9.99805C3.75 10.5158 4.16973 10.9355 4.6875 10.9355Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 10.9355C10.5158 10.9355 10.9355 10.5158 10.9355 9.99805C10.9355 9.48028 10.5158 9.06055 9.99805 9.06055C9.48028 9.06055 9.06055 9.48028 9.06055 9.99805C9.06055 10.5158 9.48028 10.9355 9.99805 10.9355Z",
    fill: "#1A181E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 10.9355C15.8303 10.9355 16.25 10.5158 16.25 9.99805C16.25 9.48028 15.8303 9.06055 15.3125 9.06055C14.7947 9.06055 14.375 9.48028 14.375 9.99805C14.375 10.5158 14.7947 10.9355 15.3125 10.9355Z",
    fill: "#1A181E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 16.25C5.20527 16.25 5.625 15.8303 5.625 15.3125C5.625 14.7947 5.20527 14.375 4.6875 14.375C4.16973 14.375 3.75 14.7947 3.75 15.3125C3.75 15.8303 4.16973 16.25 4.6875 16.25Z",
    fill: "#1A181E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 16.25C10.5158 16.25 10.9355 15.8303 10.9355 15.3125C10.9355 14.7947 10.5158 14.375 9.99805 14.375C9.48028 14.375 9.06055 14.7947 9.06055 15.3125C9.06055 15.8303 9.48028 16.25 9.99805 16.25Z",
    fill: "#1A181E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 16.25C15.8303 16.25 16.25 15.8303 16.25 15.3125C16.25 14.7947 15.8303 14.375 15.3125 14.375C14.7947 14.375 14.375 14.7947 14.375 15.3125C14.375 15.8303 14.7947 16.25 15.3125 16.25Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsNine);
export default __webpack_public_path__ + "static/media/dots-nine.8ba542d448975edb408a1b79cf3bc80f.svg";
export { ForwardRef as ReactComponent };